import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '@/lib/queryClient';

export interface PipelineStage {
  id: number;
  name: string;
  description?: string;
  color: string;
  order: number;
}

export function usePipelineStages() {
  const {
    data: stages,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['/api/pipeline-stages'],
    queryFn: () => apiRequest<PipelineStage[]>('GET', '/api/pipeline-stages'),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  return {
    stages,
    isLoading,
    error,
  };
}
